import { all, update, remove } from '../services/restApi'
import { message } from 'antd'
message.config({top: 110, duration: 4});
const _ = require('underscore')

const limit = 50;

export default {
	namespace : 'activity',
	state : {
		activities: [],
		skip: 0,
		limit: limit,
		total_items: 0,
	},
	subscriptions : {
		setup({dispatch, history}) {

			/*history.listen(location => {
		        if (location.pathname === '/activities') {
		          	dispatch({type: 'firstLoad'})
		        }
		    })*/
		}
	},
	effects : {
		*query({payload}, {call, put}) {
			yield put({type: 'app/showLoadingTable'})

			try {
				// Model
				const data = {...payload, include: 'createdBy,category,category.companies'};

				const resp = yield call(all, 'Activity', data)
				const activities = resp.results;

				yield put({ type: 'querySuccess', payload: {
					activities: activities,
					skip: payload.skip + limit,
					total_items: resp.count
				}})

			} catch (e) {
				if (e && e.data) message.error(e.data.error);
				else message.error('Ha ocurrido un error. Intente más tarde')
			}

			yield put({type: 'app/hideLoadingTable'})
		},
		*update({payload}, {call, put}) {
			yield put({type: 'app/showButtonLoading'})

			try {

				let data = {...payload}
				data = _.omit(data, ['objectId', 'createdAt', 'updatedAt']);

				yield call(update, 'Activity', payload.objectId, data);
				message.success('Se ha actualizado el registro exitosamente');

			} catch (e) {
				if (e && e.data) message.error(e.data.error);
				else message.error('Ha ocurrido un error. Intente más tarde')	
			}

			yield put({type: 'app/hideButtonLoading'})

		},
		*removeItem({payload}, {call, put}) {
			yield put({type: 'app/showLoadingTable'})

			try {
				yield call(remove, 'Activity', payload.objectId);
				yield put({type: 'removeSuccess', payload: payload})

			} catch (e) {
				if (e && e.data) message.error(e.data.error);
				else message.error('Ha ocurrido un error. Intente más tarde')	
			}

			yield put({type: 'app/hideLoadingTable'})

		}
	},
	reducers : {
		queryFirst(state, action) {
			return {
				...state,
				...action.payload
			}
		},
		querySuccess(state, action) {
			return {
				...state,
				activities: state.activities.concat(action.payload.activities),
				skip: action.payload.skip,
				total_items: action.payload.total_items
			}
		},
		filterSuccess(state, action) {
			return {
				activities: action.payload.activities,
				skip: 0,
				total_items: action.payload.total_items
			}
		},
		createSuccess(state, action) {
			return {
				...state,
    			activities: [action.payload, ...state.activities]
			}
		},
		updateSuccess(state, action) {
			const obj = _.find(state.activities, {objectId: action.payload.objectId})
			_.extend(obj, action.payload)

			return {
				...state,
    			...action.payload
			}
		},
		removeSuccess(state, action) {

			let activity = {};
			activity = _.find(state.activities, {objectId: action.payload.objectId});
			state.activities = _.without(state.activities, _.find(state.activities, {objectId: activity.objectId}));

			return {
				...state,
    			activities: state.activities
			}
		}
	}
}


// WEBPACK FOOTER //
// ./src/models/activity.js